// Stealth Angel rebuild: legacy bodies (68 product, page and article bodies) mark images with data-src for the old
// theme's lazy-loader, some with only a placeholder in src. Promote data-src/data-srcset so the real images load;
// the browser's native lazy loading takes over.
for (const img of document.querySelectorAll('.sas-rte img[data-src], .sas-rte img[data-srcset]')) {
  img.loading = 'lazy';
  if (img.dataset.srcset) img.srcset = img.dataset.srcset;
  if (img.dataset.src) img.src = img.dataset.src;
}
